import { getIn } from '@gogame/form';

import {
  ADD_NODE,
  SET_FIELD_VALUE,
  RESET_BUDGET,
  APPLY_METRIC_BELLOW,
} from './reducer';

const getChildrenNodes = ({ nodes, ...node }) => {
  const childrenNodes = nodes.map(getChildrenNodes);
  return [node, ...childrenNodes.flat()];
};

export default (state, action) => {
  switch (action.type) {
    case ADD_NODE: {
      return action.payload.nodes;
    }

    case SET_FIELD_VALUE: {
      const { levelPath } = action.payload;
      /* eslint-disable-next-line */
      const { nodes, ...changedNode } = getIn(state, levelPath);
      return [changedNode];
    }

    case RESET_BUDGET: {
      const { levelPath } = action.payload;
      const { nodes } = getIn(state, levelPath);
      /* eslint-disable-next-line */
      return nodes.map(({ nodes, ...changedNode }) => changedNode);
    }

    case APPLY_METRIC_BELLOW: {
      const { levelPath } = action.payload;
      const levelValue = getIn(state, levelPath);
      return getChildrenNodes(levelValue);
    }
  }
};
